import { createFileRoute } from '@tanstack/react-router';
import { CrmPreviewPage } from '@/pages/Crm/CrmPreviewPage';
import { AclRoute, withPermission } from '@/lib/acl';
import { crmNavItem } from '@/lib/crm/crm-nav';

function Preview() {
  return <CrmPreviewPage navId="settings" />;
}

export const Route = createFileRoute('/crm/settings')({
  component: withPermission(Preview, { key: crmNavItem('settings').access, route: AclRoute.CRM, resourceLabel: 'CRM settings' }),
});
